import { createFileRoute } from "@tanstack/react-router";

import ComposePage from "@/app/admin/compose/ComposePage";

export const Route = createFileRoute("/admin/compose")({
  component: ComposePage,
});
